import React, { useState, useEffect, useCallback } from 'react';
import { collection, addDoc, getDocs, doc, deleteDoc, updateDoc, arrayUnion, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

// Cloudinary Configuration
const CLOUD_NAME = 'dodw9wq5x';
const UPLOAD_PRESET = 'test12';

// Telegram Bot Configuration - REPLACE WITH YOUR ACTUAL TOKEN AND CHAT ID
const TELEGRAM_BOT_TOKEN = 'YOUR_TELEGRAM_BOT_TOKEN'; // Replace with your bot token
const TELEGRAM_CHAT_ID = 'YOUR_TELEGRAM_CHAT_ID'; // Replace with your channel/chat ID

// Styles
const styles = `
  .user-management {
    max-width: 1800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e0e0e0;
  }

  .header h1 {
    color: #333;
    margin: 0;
  }

  .create-user-btn {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s;
  }

  .create-user-btn:hover {
    background-color: #0056b3;
  }

  .user-form-container {
    background-color: #f8f9fa;
    padding: 30px;
    border-radius: 8px;
    margin-bottom: 30px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .user-form {
    display: flex;
    flex-direction: column;
  }

  .user-form h2 {
    margin-bottom: 20px;
    color: #333;
  }

  .form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .form-group {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .form-group label {
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
  }

  .form-group input,
  .form-group select {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }

  .form-group input:focus,
  .form-group select:focus {
    outline: none;
    border-color: #007bff;
  }

  .photo-preview {
    margin-top: 10px;
    max-width: 100px;
    max-height: 100px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .submit-btn {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
    transition: background-color 0.3s;
  }

  .submit-btn:hover:not(:disabled) {
    background-color: #218838;
  }

  .submit-btn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }

  .users-table-container {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow: hidden;
  }

  .users-table-container h2 {
    padding: 20px;
    margin: 0;
    background-color: #f8f9fa;
    color: #333;
  }

  .users-table {
    width: 100%;
    border-collapse: collapse;
  }

  .users-table th,
  .users-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }

  .users-table th {
    background-color: #f8f9fa;
    font-weight: bold;
    color: #555;
  }

  .users-table tr:hover {
    background-color: #f5f5f5;
  }

  .user-photo {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .delete-btn {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
    margin: 2px;
  }

  .delete-btn:hover {
    background-color: #c82333;
  }

  .pay-btn {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
    margin: 2px;
  }

  .pay-btn:hover {
    background-color: #218838;
  }

  .payment-history-btn {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
    margin: 2px;
  }

  .payment-history-btn:hover {
    background-color: #138496;
  }

  .forma083-btn {
    background-color: #6f42c1;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
    margin: 2px;
  }

  .forma083-btn:hover {
    background-color: #5a359c;
  }

  .forma083-pay-btn {
    background-color: #e83e8c;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
    margin: 2px;
  }

  .forma083-pay-btn:hover {
    background-color: #d91a72;
  }

  .forma083-history-btn {
    background-color: #fd7e14;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
    margin: 2px;
  }

  .forma083-history-btn:hover {
    background-color: #e66a02;
  }

  .loading {
    text-align: center;
    padding: 20px;
    color: #666;
  }

  .error {
    background-color: #f8d7da;
    color: #721c24;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 20px;
    border: 1px solid #f5c6cb;
  }

  .success {
    background-color: #d4edda;
    color: #155724;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 20px;
    border: 1px solid #c3e6cb;
  }

  .cloudinary-status {
    background-color: #d4edda;
    padding: 10px 15px;
    border-radius: 6px;
    margin-bottom: 20px;
    border-left: 4px solid #28a745;
  }

  .telegram-config {
    background-color: #e7f3ff;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
    border-left: 4px solid #17a2b8;
  }

  .debt-paid {
    color: #28a745;
    font-weight: bold;
  }

  .debt-pending {
    color: #dc3545;
    font-weight: bold;
  }

  .forma083-not-set {
    color: #6c757d;
    font-style: italic;
  }

  .forma083-price-set {
    color: #6f42c1;
    font-weight: bold;
  }

  .payment-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .payment-modal-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    width: 400px;
    max-width: 90%;
  }

  .payment-modal h3 {
    margin-top: 0;
    color: #333;
  }

  .payment-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .payment-form-group {
    display: flex;
    flex-direction: column;
  }

  .payment-form-group label {
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
  }

  .payment-form-group input {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }

  .payment-buttons {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }

  .confirm-pay-btn {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    flex: 1;
  }

  .confirm-pay-btn:hover {
    background-color: #218838;
  }

  .cancel-pay-btn {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    flex: 1;
  }

  .cancel-pay-btn:hover {
    background-color: #5a6268;
  }

  .payment-history-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .payment-history-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    width: 500px;
    max-width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }

  .payment-history-item {
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .payment-history-item:last-child {
    border-bottom: none;
  }

  .payment-amount {
    font-weight: bold;
    color: #28a745;
  }

  .payment-date {
    color: #666;
    font-size: 12px;
  }

  .close-history-btn {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
    width: 100%;
  }

  .close-history-btn:hover {
    background-color: #5a6268;
  }

  .forma083-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .forma083-modal-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    width: 500px;
    max-width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }

  .forma083-tabs {
    display: flex;
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
  }

  .forma083-tab {
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    background: none;
    border-bottom: 2px solid transparent;
    flex: 1;
    text-align: center;
  }

  .forma083-tab.active {
    border-bottom: 2px solid #6f42c1;
    color: #6f42c1;
    font-weight: bold;
  }

  .forma083-tab-content {
    display: none;
  }

  .forma083-tab-content.active {
    display: block;
  }

  .forma083-summary {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
  }

  .forma083-summary-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .forma083-summary-item:last-child {
    margin-bottom: 0;
  }

  .price-set-message {
    background-color: #e7f3ff;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
    border-left: 4px solid #6f42c1;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
      gap: 15px;
    }
    
    .users-table {
      display: block;
      overflow-x: auto;
    }
    
    .header {
      flex-direction: column;
      gap: 15px;
      text-align: center;
    }
    
    .users-table th,
    .users-table td {
      padding: 8px 4px;
      font-size: 12px;
    }

    .payment-buttons {
      flex-direction: column;
    }

    .forma083-tabs {
      flex-direction: column;
    }
  }
`;

// Telegram Bot Functions
const sendTelegramMessage = async (message, botToken, chatId) => {
  if (!botToken || !chatId) {
    console.warn('Telegram bot token yoki chat ID sozlanmagan');
    return false;
  }

  try {
    const response = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
        parse_mode: 'HTML'
      })
    });

    const data = await response.json();

    if (data.ok) {
      console.log('Telegram xabari muvaffaqiyatli yuborildi');
      return true;
    } else {
      console.error('Telegram xabarini yuborishda xatolik:', data);
      return false;
    }
  } catch (error) {
    console.error('Telegram xabarini yuborishda xatolik:', error);
    return false;
  }
};

const sendPaymentNotification = async (user, paymentType, amount, totalPaid, debtRemaining, botToken, chatId) => {
  const emoji = paymentType === '083 Forma' ? '📋' : '💰';
  const message = `
${emoji} <b>YANGI TO'LOV AMALGA OSHIRILDI</b>

👤 <b>Foydalanuvchi:</b> ${user.name} ${user.surname}
📄 <b>To'lov turi:</b> ${paymentType}
💵 <b>To'lov miqdori:</b> $${parseFloat(amount).toFixed(2)}
💰 <b>Jami to'langan:</b> $${parseFloat(totalPaid).toFixed(2)}
📊 <b>Qolgan qarz:</b> $${parseFloat(debtRemaining).toFixed(2)}

⏰ <i>${new Date().toLocaleString('uz-UZ')}</i>
  `;

  return await sendTelegramMessage(message, botToken, chatId);
};

const sendForma083PriceSetNotification = async (user, price, botToken, chatId) => {
  const message = `
📋 <b>083 FORMA NARXI BELGILANDI</b>

👤 <b>Foydalanuvchi:</b> ${user.name} ${user.surname}
💰 <b>Belgilangan narx:</b> $${parseFloat(price).toFixed(2)}
⚠️ <b>Eslatma:</b> Bu narx faqat bir marta belgilanishi mumkin

⏰ <i>${new Date().toLocaleString('uz-UZ')}</i>
  `;

  return await sendTelegramMessage(message, botToken, chatId);
};

// Main Component
const UserManagement = ({ adminLocation, onLogout, userRole }) => {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [dbInitialized, setDbInitialized] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showForma083Modal, setShowForma083Modal] = useState(false);
  const [showForma083HistoryModal, setShowForma083HistoryModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState('');
  const [forma083Price, setForma083Price] = useState('');
  const [forma083PaymentAmount, setForma083PaymentAmount] = useState('');
  const [activeForma083Tab, setActiveForma083Tab] = useState('setPrice');
  const [telegramConfig, setTelegramConfig] = useState({
    botToken: TELEGRAM_BOT_TOKEN,
    chatId: TELEGRAM_CHAT_ID
  });

  // Form state
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    location: '',
    price: '',
    passportId: '',
    category: '',
    phoneNumber: '',
    comment: '',
    photo: ''
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle telegram config changes
  const handleTelegramConfigChange = (e) => {
    const { name, value } = e.target;
    setTelegramConfig(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Save telegram config
  const handleSaveTelegramConfig = () => {
    localStorage.setItem('telegramBotToken', telegramConfig.botToken);
    localStorage.setItem('telegramChatId', telegramConfig.chatId);
    setSuccess('Telegram sozlamalari saqlandi!');
  };

  // Check Firebase connection
  const checkFirebaseConnection = async () => {
    try {
      await getDocs(collection(db, 'images'));
      setDbInitialized(true);
      return true;
    } catch (error) {
      console.error('Firebase connection error:', error);
      setError('Firebase bilan ulanishda xatolik. Firestore qoidalarini tekshiring.');
      setDbInitialized(false);
      return false;
    }
  };

  // Fetch users from Firebase
  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      setError('');

      const isConnected = await checkFirebaseConnection();
      if (!isConnected) return;

      // Get admin location from prop or localStorage (with fallback to Firestore)
      let location = adminLocation || localStorage.getItem('adminLocation') || '';
      const isSuperAdmin = localStorage.getItem('userRole') === 'superadmin';
      
      // If location is not found and user is not superadmin, try to fetch from Firestore
      if (!location && !isSuperAdmin) {
        try {
          const currentUserEmail = localStorage.getItem('userEmail') || '';
          if (currentUserEmail) {
            const adminsSnapshot = await getDocs(collection(db, 'newadmins'));
            adminsSnapshot.forEach((doc) => {
              const adminData = doc.data();
              if (adminData.email === currentUserEmail.toLowerCase().trim()) {
                location = adminData.location || '';
                if (location) {
                  localStorage.setItem('adminLocation', location);
                  console.log('✅ Admin location fetched from Firestore:', location);
                }
              }
            });
          }
        } catch (err) {
          console.warn('Could not fetch admin location from Firestore:', err);
        }
      }
      
      // Normalize admin location once
      const adminLocationNormalized = location ? location.toString().toLowerCase().trim() : '';

      // Debug logging
      console.log('🔍 Fetching users with filters:', {
        adminLocation: location,
        adminLocationNormalized: adminLocationNormalized,
        isSuperAdmin,
        adminLocationProp: adminLocation,
        localStorageLocation: localStorage.getItem('adminLocation'),
        userRole: localStorage.getItem('userRole')
      });

      const querySnapshot = await getDocs(collection(db, 'images'));
      const usersList = [];
      let totalUsers = 0;
      let filteredOut = 0;
      let matchedUsers = 0;
      
      querySnapshot.forEach((doc) => {
        const userData = doc.data();
        totalUsers++;
        
        // Filter by location if admin is not superadmin and location is set
        if (!isSuperAdmin && adminLocationNormalized) {
          // Normalize user location string (handle null, undefined, empty)
          const userLocationRaw = userData.location || '';
          const userLocationNormalized = userLocationRaw.toString().toLowerCase().trim();
          
          const matches = userLocationNormalized === adminLocationNormalized;
          
          console.log(`📍 User ${userData.name || doc.id}:`, {
            rawUserLocation: userData.location,
            adminLocation: adminLocationNormalized,
            userLocation: userLocationNormalized,
            matches: matches
          });
          
          // Only include users that match the admin's location exactly
          if (!matches) {
            filteredOut++;
            return; // Skip this user - location doesn't match
          }
          
          matchedUsers++;
        }

        // Adapt images collection data structure to match expected format
        const adaptedUserData = {
          id: doc.id,
          ...userData,
          // Map images collection fields to expected format
          name: userData.name ? userData.name.split(' ')[0] || '' : '',
          surname: userData.name ? userData.name.split(' ').slice(1).join(' ') || '' : '',
          location: userData.location || '',
          phone: userData.phone || '',
          phoneNumber: userData.phone || userData.phoneNumber || '',
          passportId: userData.passportId || '',
          imageUrl: userData.imageUrl || '',
          photo: userData.imageUrl || '',
          // Calculate debt from agreedAmount and debtPayments
          price: userData.agreedAmount || 0,
          paidAmount: userData.debtPayments ? userData.debtPayments.reduce((sum, p) => sum + (p.amount || 0), 0) : 0,
          debt: userData.agreedAmount ? (userData.agreedAmount - (userData.debtPayments ? userData.debtPayments.reduce((sum, p) => sum + (p.amount || 0), 0) : 0)) : 0,
          // Calculate 083 forma debt
          forma083Price: userData.agreedAmountForma083 || 0,
          forma083PaidAmount: userData.forma083Payments ? userData.forma083Payments.reduce((sum, p) => sum + (p.amount || 0), 0) : 0,
          forma083Debt: userData.agreedAmountForma083 ? (userData.agreedAmountForma083 - (userData.forma083Payments ? userData.forma083Payments.reduce((sum, p) => sum + (p.amount || 0), 0) : 0)) : 0,
          // Keep original fields
          debtPayments: userData.debtPayments || [],
          forma083Payments: userData.forma083Payments || [],
          tugatganligi: userData.tugatganligi || false,
          uploadedAt: userData.uploadedAt,
          category: userData.category || 'N/A'
        };
        
        usersList.push(adaptedUserData);
      });

      console.log('✅ Users fetched:', {
        totalUsers,
        filteredOut,
        matchedUsers,
        displayedUsers: usersList.length,
        isSuperAdmin,
        adminLocation: location,
        adminLocationNormalized: adminLocationNormalized
      });

      setUsers(usersList);
      
      // Show warning if no users found and location filter is active
      if (usersList.length === 0 && !isSuperAdmin && adminLocationNormalized) {
        setError(`⚠️ "${location}" lokatsiyasida foydalanuvchilar topilmadi. 
        
Tekshirilgan: ${totalUsers} ta foydalanuvchi
Filtrdan o'tkazilgan: ${filteredOut} ta
        
Iltimos, quyidagilarni tekshiring:
- Foydalanuvchilarning "location" maydoni "${location}" bilan to'liq mos keladimi?
- Lokatsiya nomi katta-kichik harflarga sezgirmi? (Kod avtomatik tuzatadi)
- Foydalanuvchilarda location maydoni mavjudmi va to'ldirilganmi?`);
      } else if (usersList.length > 0) {
        // Clear any previous errors if users are found
        setError('');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.code === 'permission-denied') {
        setError('Firebase ruxsati rad etildi. Firestore xavfsizlik qoidalarini tekshiring.');
      } else {
        setError('Foydalanuvchilarni yuklashda xatolik. Iltimos, qaytadan urinib ko\'ring.');
      }
    } finally {
      setLoading(false);
    }
  }, [adminLocation]);

  useEffect(() => {
    fetchUsers();
    // Load telegram config from localStorage
    const savedToken = localStorage.getItem('telegramBotToken');
    const savedChatId = localStorage.getItem('telegramChatId');
    if (savedToken || savedChatId) {
      setTelegramConfig({
        botToken: savedToken || TELEGRAM_BOT_TOKEN,
        chatId: savedChatId || TELEGRAM_CHAT_ID
      });
    }
  }, [fetchUsers]); // Refetch when fetchUsers changes

  // Handle photo upload to Cloudinary - FIXED URL
  const handlePhotoUpload = async (file) => {
    setLoading(true);
    setError('');
    try {
      const uploadData = new FormData();
      uploadData.append('file', file);
      uploadData.append('upload_preset', UPLOAD_PRESET);
      uploadData.append('cloud_name', CLOUD_NAME);

      console.log('Uploading to Cloudinary with preset:', UPLOAD_PRESET);

      // FIXED: Correct Cloudinary URL
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        {
          method: 'POST',
          body: uploadData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || `Upload failed with status ${response.status}`);
      }

      console.log('Upload successful:', data);
      setFormData(prev => ({
        ...prev,
        photo: data.secure_url
      }));
      setSuccess('Rasm Cloudinary-ga muvaffaqiyatli yuklandi!');
    } catch (error) {
      console.error('Cloudinary upload error:', error);
      setError(`Yuklashda xatolik: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setError('Iltimos, rasm faylini tanlang (JPEG, PNG, va hokazo).');
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setError('Rasm hajmi 5MB dan kichik bo\'lishi kerak.');
        return;
      }

      handlePhotoUpload(file);
    }
  };

  // Create new user
  const handleCreateUser = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Simple rate limit: 1 user per minute per browser
    const lastCreatedAt = localStorage.getItem('lastUserCreatedAt');
    if (lastCreatedAt) {
      const diffMs = Date.now() - Number(lastCreatedAt);
      const oneMinuteMs = 60 * 1000;
      if (diffMs < oneMinuteMs) {
        const remainingSec = Math.ceil((oneMinuteMs - diffMs) / 1000);
        alert(`Siz bir daqiqada faqat 1 ta foydalanuvchi yarata olasiz. Iltimos, ${remainingSec} soniya kuting.`);
        return;
      }
    }

    try {
      if (!formData.name || !formData.surname || !formData.passportId) {
        setError('Iltimos, barcha majburiy maydonlarni to\'ldiring (Ism, Familiya, Pasport ID).');
        return;
      }

      setLoading(true);

      const isConnected = await checkFirebaseConnection();
      if (!isConnected) return;

      await addDoc(collection(db, 'images'), {
        name: `${formData.name} ${formData.surname}`.trim(),
        location: formData.location || 'N/A',
        phone: formData.phoneNumber || 'N/A',
        passportId: formData.passportId || 'N/A',
        comment: formData.comment || '',
        imageUrl: formData.photo || '',
        agreedAmount: parseFloat(formData.price) || 0,
        agreedAmountForma083: null,
        debtPayments: [],
        forma083Payments: [],
        tugatganligi: false,
        uploadedAt: new Date(),
        category: formData.category || 'N/A'
      });

      setFormData({
        name: '',
        surname: '',
        location: '',
        price: '',
        passportId: '',
        category: '',
        phoneNumber: '',
        comment: '',
        photo: ''
      });
      setShowForm(false);
      setSuccess('Foydalanuvchi muvaffaqiyatli yaratildi!');
      localStorage.setItem('lastUserCreatedAt', Date.now().toString());
      fetchUsers();
    } catch (error) {
      console.error('Error creating user:', error);
      if (error.code === 'permission-denied') {
        setError('Firebase ruxsati rad etildi. Firestore xavfsizlik qoidalarini tekshiring.');
      } else {
        setError('Foydalanuvchi yaratishda xatolik. Iltimos, qaytadan urinib ko\'ring.');
      }
    } finally {
      setLoading(false);
    }
  };

  // Delete user
  const handleDeleteUser = async (userId) => {
    if (window.confirm('Haqiqatan ham bu foydalanuvchini o\'chirmoqchimisiz?')) {
      try {
        setLoading(true);
        const isConnected = await checkFirebaseConnection();
        if (!isConnected) return;

        await deleteDoc(doc(db, 'images', userId));
        setSuccess('Foydalanuvchi muvaffaqiyatli o\'chirildi!');
        fetchUsers();
      } catch (error) {
        console.error('Error deleting user:', error);
        if (error.code === 'permission-denied') {
          setError('Firebase ruxsati rad etildi. Firestore xavfsizlik qoidalarini tekshiring.');
        } else {
          setError('Foydalanuvchini o\'chirishda xatolik. Iltimos, qaytadan urinib ko\'ring.');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  // Open payment modal
  const handleOpenPayment = (user) => {
    setSelectedUser(user);
    setPaymentAmount('');
    setShowPaymentModal(true);
  };

  // Open payment history modal
  const handleOpenHistory = (user) => {
    setSelectedUser(user);
    setShowHistoryModal(true);
  };

  // Open 083 forma modal
  const handleOpenForma083 = (user) => {
    setSelectedUser(user);
    setForma083Price('');
    setForma083PaymentAmount('');
    setActiveForma083Tab(user.forma083PriceSet ? 'pay' : 'setPrice');
    setShowForma083Modal(true);
  };

  // Open 083 forma history modal
  const handleOpenForma083History = (user) => {
    setSelectedUser(user);
    setShowForma083HistoryModal(true);
  };

  // Process payment
  const handleProcessPayment = async () => {
    if (!paymentAmount || paymentAmount <= 0) {
      setError('Iltimos, to\'g\'ri to\'lov miqdorini kiriting.');
      return;
    }

    if (parseFloat(paymentAmount) > selectedUser.debt) {
      setError('To\'lov miqdori qarzdan ko\'p bo\'lishi mumkin emas.');
      return;
    }

    try {
      setLoading(true);
      const userRef = doc(db, 'images', selectedUser.id);
      
      // Use images collection structure: debtPayments array with {amount, timestamp}
      const paymentRecord = {
        amount: parseFloat(paymentAmount),
        timestamp: new Date().toISOString()
      };

      await updateDoc(userRef, {
        debtPayments: arrayUnion(paymentRecord),
        lastPaymentAt: serverTimestamp()
      });

      // Calculate new values for notification
      const currentPaid = (selectedUser.debtPayments || []).reduce((sum, p) => sum + (p.amount || 0), 0) + parseFloat(paymentAmount);
      const currentDebt = (selectedUser.agreedAmount || selectedUser.price || 0) - currentPaid;
      
      // Send Telegram notification
      await sendPaymentNotification(
        selectedUser,
        'Asosiy to\'lov',
        paymentAmount,
        currentPaid,
        currentDebt,
        telegramConfig.botToken,
        telegramConfig.chatId
      );

      setShowPaymentModal(false);
      setSuccess(`$${parseFloat(paymentAmount).toFixed(2)} miqdoridagi to'lov muvaffaqiyatli amalga oshirildi! Telegram xabari yuborildi.`);
      fetchUsers();
    } catch (error) {
      console.error('Error processing payment:', error);
      setError('To\'lovni amalga oshirishda xatolik. Iltimos, qaytadan urinib ko\'ring.');
    } finally {
      setLoading(false);
    }
  };

  // Set 083 forma price (ONLY ONCE)
  const handleSetForma083Price = async () => {
    if (!forma083Price || forma083Price <= 0) {
      setError('Iltimos, 083 forma uchun to\'g\'ri narx kiriting.');
      return;
    }

    if (selectedUser.forma083PriceSet) {
      setError('083 forma narxi allaqachon belgilangan va o\'zgartirib bo\'lmaydi.');
      return;
    }

    try {
      setLoading(true);
      const userRef = doc(db, 'images', selectedUser.id);
      const newForma083Price = parseFloat(forma083Price);

      await updateDoc(userRef, {
        agreedAmountForma083: newForma083Price,
        forma083PriceSetAt: serverTimestamp()
      });

      // Send Telegram notification
      await sendForma083PriceSetNotification(
        selectedUser,
        newForma083Price,
        telegramConfig.botToken,
        telegramConfig.chatId
      );

      setSuccess(`083 forma narxi $${newForma083Price.toFixed(2)} ga muvaffaqiyatli belgilandi! Narxni keyin o'zgartirib bo'lmaydi. Telegram xabari yuborildi.`);
      setShowForma083Modal(false);
      fetchUsers();
    } catch (error) {
      console.error('Error setting 083 forma price:', error);
      setError('083 forma narxini belgilashda xatolik. Iltimos, qaytadan urinib ko\'ring.');
    } finally {
      setLoading(false);
    }
  };

  // Process 083 forma payment
  const handleProcessForma083Payment = async () => {
    if (!forma083PaymentAmount || forma083PaymentAmount <= 0) {
      setError('Iltimos, 083 forma uchun to\'g\'ri to\'lov miqdorini kiriting.');
      return;
    }

    if (parseFloat(forma083PaymentAmount) > selectedUser.forma083Debt) {
      setError('To\'lov miqdori 083 forma qarzidan ko\'p bo\'lishi mumkin emas.');
      return;
    }

    try {
      setLoading(true);
      const userRef = doc(db, 'images', selectedUser.id);
      
      // Use images collection structure: forma083Payments array with {amount, timestamp}
      const paymentRecord = {
        amount: parseFloat(forma083PaymentAmount),
        timestamp: new Date().toISOString()
      };

      await updateDoc(userRef, {
        forma083Payments: arrayUnion(paymentRecord),
        lastPaymentAt: serverTimestamp()
      });

      // Calculate new values for notification
      const currentForma083Paid = (selectedUser.forma083Payments || []).reduce((sum, p) => sum + (p.amount || 0), 0) + parseFloat(forma083PaymentAmount);
      const currentForma083Debt = (selectedUser.agreedAmountForma083 || selectedUser.forma083Price || 0) - currentForma083Paid;

      // Send Telegram notification
      await sendPaymentNotification(
        selectedUser,
        '083 Forma',
        forma083PaymentAmount,
        currentForma083Paid,
        currentForma083Debt,
        telegramConfig.botToken,
        telegramConfig.chatId
      );

      setShowForma083Modal(false);
      setSuccess(`083 forma to'lovi $${parseFloat(forma083PaymentAmount).toFixed(2)} miqdorida muvaffaqiyatli amalga oshirildi! Telegram xabari yuborildi.`);
      fetchUsers();
    } catch (error) {
      console.error('Error processing 083 forma payment:', error);
      setError('083 forma to\'lovini amalga oshirishda xatolik. Iltimos, qaytadan urinib ko\'ring.');
    } finally {
      setLoading(false);
    }
  };

  // Format price display
  const formatPrice = (price) => {
    return typeof price === 'number' ? `$${price.toFixed(2)}` : `$${parseFloat(price || 0).toFixed(2)}`;
  };

  // Format date
  const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = date.toDate ? date.toDate() : new Date(date);
    return d.toLocaleDateString('uz-UZ') + ' ' + d.toLocaleTimeString('uz-UZ');
  };

  return (
    <>
      <style>{styles}</style>
      <div className="user-management">
        <div className="header">
          <div>
            <h1>Foydalanuvchi Boshqaruv Tizimi</h1>
            {(() => {
              const location = adminLocation || localStorage.getItem('adminLocation');
              const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';
              if (isSuperAdmin) {
                return <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>👑 Super Admin - Barcha lokatsiyalardagi foydalanuvchilar ko'rsatilmoqda</p>;
              } else if (location) {
                return (
                  <div style={{ margin: '5px 0 0 0' }}>
                    <p style={{ color: '#666', fontSize: '14px', margin: '0 0 5px 0' }}>
                      📍 Lokatsiya: <strong style={{ color: '#2ea44f' }}>{location}</strong> - Faqat bu lokatsiyadagi foydalanuvchilar ko'rsatilmoqda
                    </p>
                    <p style={{ color: '#856404', fontSize: '12px', margin: 0, fontStyle: 'italic' }}>
                      💡 Agar foydalanuvchilar ko'rinmasa, ularning "location" maydoni "{location}" bilan to'liq mos kelishi kerak
                    </p>
                  </div>
                );
              } else {
                return (
                  <p style={{ margin: '5px 0 0 0', color: '#d73a49', fontSize: '14px' }}>
                    ⚠️ Lokatsiya topilmadi. Iltimos, qayta login qiling.
                  </p>
                );
              }
            })()}
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {userRole === 'superadmin' && (
              <button
                className="create-user-btn"
                onClick={() => window.location.href = '/admin'}
                style={{ backgroundColor: '#6c757d' }}
              >
                Admin Boshqaruvi
              </button>
            )}
            <button
              className="create-user-btn"
              onClick={() => setShowForm(!showForm)}
              disabled={loading}
            >
              {showForm ? 'Bekor qilish' : 'Foydalanuvchi Yaratish'}
            </button>
            {onLogout && (
              <button
                className="create-user-btn"
                onClick={onLogout}
                style={{ backgroundColor: '#dc3545' }}
              >
                Chiqish
              </button>
            )}
          </div>
        </div>

        {!dbInitialized && (
          <div className="error" style={{ backgroundColor: '#fff3cd', color: '#856404', borderColor: '#ffeaa7' }}>
            ⚠️ Firebase ga ulanmadi. Iltimos, Firestore qoidalarini tekshiring.
          </div>
        )}

        {/* Telegram Configuration */}
        <div className="telegram-config">
          <h3>📱 Telegram Bot Sozlamalari</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Bot Token:</label>
              <input
                type="text"
                name="botToken"
                value={telegramConfig.botToken}
                onChange={handleTelegramConfigChange}
                placeholder="Bot tokenini kiriting"
              />
            </div>
            <div className="form-group">
              <label>Chat ID:</label>
              <input
                type="text"
                name="chatId"
                value={telegramConfig.chatId}
                onChange={handleTelegramConfigChange}
                placeholder="Chat ID ni kiriting"
              />
            </div>
          </div>
          <button
            className="submit-btn"
            onClick={handleSaveTelegramConfig}
            style={{ backgroundColor: '#17a2b8', marginTop: '10px' }}
          >
            Sozlamalarni Saqlash
          </button>
          <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
            ℹ️ Bot tokeni va chat ID ni kiriting. To'lovlar haqida xabarlar shu chatga yuboriladi.
          </div>
        </div>

        {showForm && (
          <div className="cloudinary-status">
            ✅ Cloudinary sozlandi: <strong>Cloud Name:</strong> {CLOUD_NAME}, <strong>Upload Preset:</strong> {UPLOAD_PRESET}
          </div>
        )}

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        {/* Create User Form */}
        {showForm && (
          <div className="user-form-container">
            <form onSubmit={handleCreateUser} className="user-form">
              <h2>Yangi Foydalanuvchi Yaratish</h2>

              <div className="form-row">
                <div className="form-group">
                  <label>Ism *:</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                    placeholder="Ismni kiriting"
                  />
                </div>

                <div className="form-group">
                  <label>Familiya *:</label>
                  <input
                    type="text"
                    name="surname"
                    value={formData.surname}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                    placeholder="Familiyani kiriting"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Manzil:</label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    disabled={loading}
                    placeholder="Manzilni kiriting"
                  />
                </div>

                <div className="form-group">
                  <label>Narx ($) *:</label>
                  <input
                    type="number"
                    step="0.01"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Pasport ID *:</label>
                  <input
                    type="text"
                    name="passportId"
                    value={formData.passportId}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                    placeholder="Pasport ID ni kiriting"
                  />
                </div>

                <div className="form-group">
                  <label>Kategoriya:</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    disabled={loading}
                  >
                    <option value="">Kategoriyani tanlang</option>
                    <option value="A">Kategoriya A</option>
                    <option value="B">Kategoriya B</option>
                    <option value="C">Kategoriya C</option>
                    <option value="D">Kategoriya D</option>
                    <option value="Boshqa">Boshqa</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Telefon raqami:</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    disabled={loading}
                    placeholder="Telefon raqamini kiriting"
                  />
                </div>

                <div className="form-group">
                  <label>Comment:</label>
                  <textarea
                    name="comment"
                    value={formData.comment}
                    onChange={handleInputChange}
                    disabled={loading}
                    rows={3}
                    placeholder="Izoh yoki qo'shimcha ma'lumot kiriting"
                    style={{ resize: 'vertical' }}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Rasm:</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    disabled={loading}
                  />
                  {loading && <div className="loading">Rasm yuklanmoqda...</div>}
                  {formData.photo && (
                    <div>
                      <img
                        src={formData.photo}
                        alt="Ko'rib chiqish"
                        className="photo-preview"
                      />
                      <div style={{ fontSize: '12px', color: 'green' }}>✓ Rasm tayyor</div>
                    </div>
                  )}
                </div>
              </div>

              <button type="submit" disabled={loading || !dbInitialized} className="submit-btn">
                {loading ? 'Yaratilmoqda...' : 'Foydalanuvchi Yaratish'}
              </button>
            </form>
          </div>
        )}

        {/* Payment Modal */}
        {showPaymentModal && selectedUser && (
          <div className="payment-modal">
            <div className="payment-modal-content">
              <h3>{selectedUser.name} {selectedUser.surname} uchun To'lovni Amalga Oshirish</h3>
              <div className="payment-form">
                <div className="payment-form-group">
                  <label>Jami Narx:</label>
                  <input type="text" value={formatPrice(selectedUser.price)} disabled />
                </div>
                <div className="payment-form-group">
                  <label>To'langan:</label>
                  <input type="text" value={formatPrice(selectedUser.paidAmount || 0)} disabled />
                </div>
                <div className="payment-form-group">
                  <label>Joriy Qarz:</label>
                  <input
                    type="text"
                    value={formatPrice(selectedUser.debt)}
                    disabled
                    className={selectedUser.debt === 0 ? 'debt-paid' : 'debt-pending'}
                  />
                </div>
                <div className="payment-form-group">
                  <label>To'lov Miqdori ($):</label>
                  <input
                    type="number"
                    step="0.01"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    placeholder="To'lov miqdorini kiriting"
                    max={selectedUser.debt}
                  />
                </div>
                <div className="payment-buttons">
                  <button className="confirm-pay-btn" onClick={handleProcessPayment} disabled={loading}>
                    {loading ? 'Amalga oshirilmoqda...' : 'To\'lovni Tasdiqlash'}
                  </button>
                  <button className="cancel-pay-btn" onClick={() => setShowPaymentModal(false)}>
                    Bekor qilish
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment History Modal */}
        {showHistoryModal && selectedUser && (
          <div className="payment-history-modal">
            <div className="payment-history-content">
              <h3>{selectedUser.name} {selectedUser.surname} uchun To'lov Tarixi</h3>
              <p><strong>Jami Narx:</strong> {formatPrice(selectedUser.price)}</p>
              <p><strong>Jami To'langan:</strong> {formatPrice(selectedUser.paidAmount || 0)}</p>
              <p><strong>Joriy Qarz:</strong> <span className={selectedUser.debt === 0 ? 'debt-paid' : 'debt-pending'}>
                {formatPrice(selectedUser.debt)}
              </span></p>

              <div style={{ marginTop: '20px' }}>
                <h4>To'lov Yozuvlari:</h4>
                {selectedUser.paymentHistory && selectedUser.paymentHistory.length > 0 ? (
                  selectedUser.paymentHistory.map((payment, index) => (
                    <div key={index} className="payment-history-item">
                      <div>
                        <div className="payment-amount">${payment.amount.toFixed(2)}</div>
                        <div className="payment-date">{formatDate(payment.date)}</div>
                      </div>
                      <div>
                        <small>Qarz: ${payment.previousDebt.toFixed(2)} → ${payment.newDebt.toFixed(2)}</small>
                      </div>
                    </div>
                  )).reverse()
                ) : (
                  <p>To'lov yozuvlari topilmadi.</p>
                )}
              </div>

              <button className="close-history-btn" onClick={() => setShowHistoryModal(false)}>
                Yopish
              </button>
            </div>
          </div>
        )}

        {/* 083 Forma Modal */}
        {showForma083Modal && selectedUser && (
          <div className="forma083-modal">
            <div className="forma083-modal-content">
              <h3>{selectedUser.name} {selectedUser.surname} uchun 083 Forma</h3>

              {/* Show message if price is already set */}
              {selectedUser.forma083PriceSet && (
                <div className="price-set-message">
                  ✅ 083 Forma narxi allaqachon <strong>{formatPrice(selectedUser.forma083Price)}</strong> ga belgilangan va o'zgartirib bo'lmaydi.
                </div>
              )}

              <div className="forma083-tabs">
                {!selectedUser.forma083PriceSet && (
                  <button
                    className={`forma083-tab ${activeForma083Tab === 'setPrice' ? 'active' : ''}`}
                    onClick={() => setActiveForma083Tab('setPrice')}
                  >
                    Narxni Belgilash
                  </button>
                )}
                <button
                  className={`forma083-tab ${activeForma083Tab === 'pay' ? 'active' : ''}`}
                  onClick={() => setActiveForma083Tab('pay')}
                >
                  To'lov Qilish
                </button>
              </div>

              {/* Set Price Tab - Only show if price is not set */}
              {!selectedUser.forma083PriceSet && (
                <div className={`forma083-tab-content ${activeForma083Tab === 'setPrice' ? 'active' : ''}`}>
                  <div className="forma083-summary">
                    <div className="forma083-summary-item">
                      <span>Joriy Narx:</span>
                      <span className="forma083-not-set">Belgilanmagan</span>
                    </div>
                    <div className="forma083-summary-item">
                      <span>To'langan:</span>
                      <span>{formatPrice(0)}</span>
                    </div>
                    <div className="forma083-summary-item">
                      <span>Joriy Qarz:</span>
                      <span className="forma083-not-set">Belgilanmagan</span>
                    </div>
                  </div>

                  <div className="payment-form">
                    <div className="payment-form-group">
                      <label>083 Forma Narxini Belgilash ($):</label>
                      <input
                        type="number"
                        step="0.01"
                        value={forma083Price}
                        onChange={(e) => setForma083Price(e.target.value)}
                        placeholder="083 forma narxini kiriting"
                      />
                    </div>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '15px' }}>
                      ⚠️ Eslatma: Bu narx faqat bir marta belgilanishi mumkin va keyin o'zgartirib bo'lmaydi.
                    </div>
                    <div className="payment-buttons">
                      <button className="confirm-pay-btn" onClick={handleSetForma083Price} disabled={loading}>
                        {loading ? 'Belgilanmoqda...' : 'Narxni Belgilash'}
                      </button>
                      <button className="cancel-pay-btn" onClick={() => setShowForma083Modal(false)}>
                        Bekor qilish
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Make Payment Tab */}
              <div className={`forma083-tab-content ${activeForma083Tab === 'pay' ? 'active' : ''}`}>
                <div className="forma083-summary">
                  <div className="forma083-summary-item">
                    <span>Jami Narx:</span>
                    <span className={selectedUser.forma083PriceSet ? 'forma083-price-set' : 'forma083-not-set'}>
                      {selectedUser.forma083PriceSet ? formatPrice(selectedUser.forma083Price) : 'Belgilanmagan'}
                    </span>
                  </div>
                  <div className="forma083-summary-item">
                    <span>To'langan:</span>
                    <span>{formatPrice(selectedUser.forma083PaidAmount || 0)}</span>
                  </div>
                  <div className="forma083-summary-item">
                    <span>Joriy Qarz:</span>
                    <span className={selectedUser.forma083Debt === 0 ? 'debt-paid' : 'debt-pending'}>
                      {selectedUser.forma083PriceSet ? formatPrice(selectedUser.forma083Debt || 0) : 'Belgilanmagan'}
                    </span>
                  </div>
                </div>

                {selectedUser.forma083PriceSet ? (
                  selectedUser.forma083Debt > 0 ? (
                    <div className="payment-form">
                      <div className="payment-form-group">
                        <label>To'lov Miqdori ($):</label>
                        <input
                          type="number"
                          step="0.01"
                          value={forma083PaymentAmount}
                          onChange={(e) => setForma083PaymentAmount(e.target.value)}
                          placeholder="To'lov miqdorini kiriting"
                          max={selectedUser.forma083Debt}
                        />
                      </div>
                      <div className="payment-buttons">
                        <button className="confirm-pay-btn" onClick={handleProcessForma083Payment} disabled={loading}>
                          {loading ? 'Amalga oshirilmoqda...' : 'To\'lovni Tasdiqlash'}
                        </button>
                        <button className="cancel-pay-btn" onClick={() => setShowForma083Modal(false)}>
                          Bekor qilish
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="success">
                      ✅ 083 Forma to'liq to'langan! To'lov talab qilinmaydi.
                    </div>
                  )
                ) : (
                  <p className="error">Iltimos, avval "Narxni Belgilash" yorlig'ida 083 forma narxini belgilang.</p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* 083 Forma History Modal */}
        {showForma083HistoryModal && selectedUser && (
          <div className="payment-history-modal">
            <div className="payment-history-content">
              <h3>{selectedUser.name} {selectedUser.surname} uchun 083 Forma To'lov Tarixi</h3>
              <p><strong>Jami Narx:</strong>
                <span className={selectedUser.forma083PriceSet ? 'forma083-price-set' : 'forma083-not-set'}>
                  {selectedUser.forma083PriceSet ? formatPrice(selectedUser.forma083Price) : 'Belgilanmagan'}
                </span>
              </p>
              <p><strong>Jami To'langan:</strong> {formatPrice(selectedUser.forma083PaidAmount || 0)}</p>
              <p><strong>Joriy Qarz:</strong> <span className={selectedUser.forma083Debt === 0 ? 'debt-paid' : 'debt-pending'}>
                {selectedUser.forma083PriceSet ? formatPrice(selectedUser.forma083Debt || 0) : 'Belgilanmagan'}
              </span></p>

              <div style={{ marginTop: '20px' }}>
                <h4>083 Forma To'lov Yozuvlari:</h4>
                {selectedUser.forma083PaymentHistory && selectedUser.forma083PaymentHistory.length > 0 ? (
                  selectedUser.forma083PaymentHistory.map((payment, index) => (
                    <div key={index} className="payment-history-item">
                      <div>
                        <div className="payment-amount">${payment.amount.toFixed(2)}</div>
                        <div className="payment-date">{formatDate(payment.date)}</div>
                      </div>
                      <div>
                        <small>Qarz: ${payment.previousDebt.toFixed(2)} → ${payment.newDebt.toFixed(2)}</small>
                      </div>
                    </div>
                  )).reverse()
                ) : (
                  <p>083 forma to'lov yozuvlari topilmadi.</p>
                )}
              </div>

              <button className="close-history-btn" onClick={() => setShowForma083HistoryModal(false)}>
                Yopish
              </button>
            </div>
          </div>
        )}

        {/* Users Table */}
        <div className="users-table-container">
          <h2>Foydalanuvchilar Ro'yxati ({users.length})</h2>
          {loading && <div className="loading">Foydalanuvchilar yuklanmoqda...</div>}

          {!loading && users.length === 0 ? (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
              {dbInitialized
                ? 'Foydalanuvchilar topilmadi. Birinchi foydalanuvchini qo\'shish uchun "Foydalanuvchi Yaratish" tugmasini bosing!'
                : 'Ma\'lumotlar bazasiga ulanib bo\'lmadi. Iltimos, Firebase sozlamalarini tekshiring.'}
            </div>
          ) : (
            <table className="users-table">
              <thead>
                <tr>
                  <th>Rasm</th>
                  <th>Ism</th>
                  <th>Familiya</th>
                  <th>Manzil</th>
                  <th>Narx</th>
                  <th>To'langan</th>
                  <th>Qarz</th>
                  <th>083 Forma Narxi</th>
                  <th>083 Forma To'langan</th>
                  <th>083 Forma Qarzi</th>
                  <th>Pasport ID</th>
                  <th>Kategoriya</th>
                  <th>Telefon raqami</th>
                  <th>Comment</th>
                  <th>Harakatlar</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>
                      {user.photo ? (
                        <img src={user.photo} alt="Foydalanuvchi" className="user-photo" />
                      ) : (
                        <div style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: '#f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '4px',
                          fontSize: '10px',
                          color: '#999'
                        }}>
                          Rasm yo'q
                        </div>
                      )}
                    </td>
                    <td>{user.name}</td>
                    <td>{user.surname}</td>
                    <td>{user.location || 'N/A'}</td>
                    <td>{formatPrice(user.price)}</td>
                    <td>{formatPrice(user.paidAmount || 0)}</td>
                    <td className={user.debt === 0 ? 'debt-paid' : 'debt-pending'}>
                      {formatPrice(user.debt)}
                    </td>
                    <td>
                      {user.forma083PriceSet ? (
                        <span className="forma083-price-set">{formatPrice(user.forma083Price)}</span>
                      ) : (
                        <span className="forma083-not-set">Belgilanmagan</span>
                      )}
                    </td>
                    <td>{formatPrice(user.forma083PaidAmount || 0)}</td>
                    <td className={user.forma083Debt === 0 ? 'debt-paid' : 'debt-pending'}>
                      {user.forma083PriceSet ? formatPrice(user.forma083Debt || 0) : 'Belgilanmagan'}
                    </td>
                    <td>{user.passportId}</td>
                    <td>{user.category || 'N/A'}</td>
                    <td>{user.phoneNumber || 'N/A'}</td>
                    <td style={{ maxWidth: '220px', whiteSpace: 'pre-wrap' }}>{user.comment || '—'}</td>
                    <td>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div>
                          <button
                            onClick={() => handleOpenPayment(user)}
                            className="pay-btn"
                            disabled={loading || user.debt === 0}
                            style={{ width: '100%' }}
                          >
                            To'lash
                          </button>
                          <button
                            onClick={() => handleOpenHistory(user)}
                            className="payment-history-btn"
                            disabled={loading}
                            style={{ width: '100%' }}
                          >
                            Tarix
                          </button>
                        </div>
                        <div>
                          <button
                            onClick={() => handleOpenForma083(user)}
                            className="forma083-btn"
                            disabled={loading}
                            style={{ width: '100%' }}
                          >
                            083 Forma
                          </button>
                          <button
                            onClick={() => handleOpenForma083History(user)}
                            className="forma083-history-btn"
                            disabled={loading || !user.forma083PriceSet}
                            style={{ width: '100%' }}
                          >
                            083 Tarix
                          </button>
                        </div>
                        <button
                          onClick={() => handleDeleteUser(user.id)}
                          className="delete-btn"
                          disabled={loading || !dbInitialized}
                          style={{ width: '100%' }}
                        >
                          O'chirish
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
};

// Main App Component
function App() {
  return (
    <div className="App">
      <UserManagement />
    </div>
  );
}

export default App;